// extracted by mini-css-extract-plugin
module.exports = {"block":"block__1VyYV","wrap":"wrap__3_ao7","includeKeyLine":"includeKeyLine__1iK7l","tick":"tick__6PCxV","tickText":"tickText__XYbaA","label":"label__IJtiZ"};